// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"79c8ffbb","402":"852435e3","424":"d8765240","551":"2c3acc5e","604":"7cb86f73","628":"4bf6ba39","685":"8f6d7469","967":"b7b7925c"}[chunkId] + ".css";
};